import { z } from "zod";

export const zAttrCheckbox = z.object({
  editor: z.literal("Checkbox"),
});
